import { render } from "./IconDiopter.vue?vue&type=template&id=cb27d2cc&lang=html"
import script from "./IconDiopter.vue?vue&type=script&lang=js"
export * from "./IconDiopter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__